@if (currentUser$ | async; as user) {
  <div class="header">
    <div class="tabs">
      <div [class.active]="currentTab === 'MEETING'" (click)="currentTab = 'MEETING'" class="clickable tab" translate="COMMON.MEETING"></div>
      <div
        [class.active]="currentTab === 'AGENDA'"
        (click)="user.role === 'SUPER' ? (currentTab = 'AGENDA') : handleAgendaTabClick()"
        class="tab"
        [class.clickable]="call.agendaDownloadUrl !== null || isAuthorizedToManageDocuments"
        [translate]="user.role === 'SUPER' ? 'CALLS.TEMPLATE' : 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.AGENDA'"
        [matTooltip]="isAuthorizedToManageDocuments ? null : ('CALLS.CALL_INFO.DOCUMENT_UPLOAD.ONLY_OWNERS_CAN_UPLOAD' | translate)"
      ></div>
      @if (showBoardPack) {
        <div
          [class.active]="currentTab === 'DOCUMENTS'"
          class="tab documents-tab"
          [class.clickable]="call.userUploadedResources.length > 0 || isAuthorizedToManageDocuments"
          [matTooltip]="isAuthorizedToManageDocuments ? null : ('CALLS.CALL_INFO.DOCUMENT_UPLOAD.ONLY_OWNERS_CAN_UPLOAD' | translate)"
        >
          @if (call.userUploadedResources.length > 0) {
            <span class="documents-tab-trigger">
              <span (click)="handleDocumentsTabClick()" class="tab-text clickable">{{ papersTabLabel }}</span>
              <mat-icon [matMenuTriggerFor]="documentsMenu" class="dropdown-icon clickable" (click)="$event.stopPropagation()">arrow_drop_down</mat-icon>
            </span>
            <mat-menu #documentsMenu="matMenu">
              @for (resource of call.userUploadedResources; track resource.id) {
                @if (resource.downloadUrl !== null) {
                  <button mat-menu-item (click)="onDocumentSelectionChange(resource.id)">
                    {{ resource.fileName }}
                  </button>
                }
              }
            </mat-menu>
          } @else {
            <span (click)="handleDocumentsTabClick()" class="clickable" translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.PAPERS"></span>
          }
        </div>
      }
    </div>
    <div class="buttons">
      @if (allowReprocessingOutputs && canEdit) {
        <div class="header-button">
          <button mat-raised-button (click)="reprocessLlm()">{{ 'CALLS.REPROCESS_OUTPUTS.TITLE' | translate }}</button>
        </div>
      }
    </div>
  </div>
  <div class="meeting-container panel" [class.hidden]="!displayMeeting">
    <as-split direction="vertical" [gutterSize]="0" [unit]="shouldMaximizeTranscript(call) ? 'pixel' : 'percent'">
      <as-split-area [size]="shouldMaximizeTranscript(call) ? 48 : 40" [lockSize]="true">
        <div class="media-container ph-no-capture">
          @if (call.isMediaReady) {
            <app-media-player
              [call]="call"
              [shouldNavigateTranscriptBasedOnMediaTime]="shouldNavigateTranscriptBasedOnMediaTime"
              [labelingModeEnabled]="(speakerLabelingModeEnabled$ | async) ?? false"
            ></app-media-player>
          }
        </div>
      </as-split-area>
      <as-split-area [size]="shouldMaximizeTranscript(call) ? '*' : 60" [lockSize]="true">
        <div class="bottom-container">
          <div class="content">
            @if (call.isTranscriptReady) {
              <div class="speaker-x-ray-container">
                <app-speaker-x-ray
                  [call]="call"
                  [canEdit]="canEdit"
                  [currentProgress]="currentProgress"
                  [activeSpeakerId]="activeSpeakerId"
                  (selectTime)="selectTimestamp($event)"
                  [showXRay]="(shouldShowSpeakers$ | async) ?? false"
                  [labelingModeEnabled]="(speakerLabelingModeEnabled$ | async) ?? false"
                ></app-speaker-x-ray>
              </div>
              <div class="transcript-container">
                @if (call.haveSpeakersBeenUpdated && canEdit) {
                  <div class="reset-speakers-container">
                    <button (click)="resetSpeakers(call)" mat-icon-button [matTooltip]="'CALLS.RESET_SPEAKERS' | translate">
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                }
                <div class="scrolling-container" (scrollend)="transcriptScroll$.next()">
                  <app-transcript [canEdit]="canEdit" [transcript]="call.transcript" [call]="call" (selectSentence)="selectSentence($event)"></app-transcript>
                </div>
                @if (!shouldNavigateTranscriptBasedOnMediaTime) {
                  <div class="jump-to-transcription-container">
                    <div class="button clickable" translate="CALLS.SYNC_TO_VIDEO" (click)="jumpToTranscript()"></div>
                  </div>
                }
              </div>
            } @else {
              <div class="centered-content">
                @if (call.isSpeechMissing) {
                  <h1>{{ 'CALLS.NO_SPEECH_MESSAGE' | translate }}</h1>
                } @else {
                  <h1>{{ 'CALLS.TRANSCRIPT_PROCESSING_MESSAGE' | translate }}</h1>
                }
              </div>
            }
          </div>
        </div>
      </as-split-area>
    </as-split>
  </div>
  @if (call.userUploadedResources.length > 0 && showBoardPack && displayDocuments) {
    <div class="document-display-container embed-container">
      @if (selectedDocumentPdfBlob !== null) {
        <ngx-extended-pdf-viewer
          #pdfViewer
          [src]="selectedDocumentPdfBlob"
          [page]="currentPdfPage"
          [activeSidebarView]="2"
          [textLayer]="true"
          [handTool]="false"
          [showToolbar]="true"
          [showSidebarButton]="true"
          [showFindButton]="true"
          [showPagingButtons]="true"
          [showZoomButtons]="true"
          [showPresentationModeButton]="false"
          [showOpenFileButton]="false"
          [showPrintButton]="false"
          [showDownloadButton]="false"
          [showSecondaryToolbarButton]="true"
          [showRotateCwButton]="true"
          [showSpreadButton]="true"
          [showHandToolButton]="true"
          [showPropertiesButton]="false"
          [contextMenuAllowed]="true"
          [useInlineScripts]="false"
          [showFirstAndLastPageButtons]="false"
          backgroundColor="#1a1a2e"
        ></ngx-extended-pdf-viewer>
      }
    </div>
  }
  <div class="document-display-container panel" [class.hidden]="!displayAgenda">
    @if (user.role === 'SUPER') {
      @if (templateItems$ | async; as templateItemsResult) {
        @if (templateItemsResult.data) {
          <app-template-editor
            #templateEditor
            [templateItems]="templateItemsResult.data"
            [availableResources]="call.userUploadedResources"
            [allowFileUpload]="isAuthorizedToManageDocuments"
            [attendeeNames]="call.attendeeNames"
            [superModeEnabled]="user.role === 'SUPER'"
            (templateSaved)="saveTemplate($event)"
            (fileUploadRequested)="handleFileUpload($event, call.id)"
            (fullscreenRequested)="openFullscreenTemplateEditor()"
          ></app-template-editor>
        }
      }
    } @else {
      @if (isAuthorizedToManageDocuments) {
        <div class="document-header">
          <button mat-raised-button (click)="removeAgenda()">
            <mat-icon>delete</mat-icon>
            {{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.REMOVE_AGENDA' | translate }}
          </button>
        </div>
      }
      @if (call.agenda.length > 0) {
        <app-agenda-editor [agenda]="call.agenda" [isReadonly]="true" [callId]="call.id"></app-agenda-editor>
      } @else {
        <h1 class="centered">{{ 'CALLS.AGENDA_EDITOR.WILL_BE_DISPLAYED_HERE' | translate }}</h1>
      }
    }
  </div>
}
